import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import About from '../components/About';
import Pricing from '../components/Pricing';
import GrowthSections from '../components/GrowthSections';

const Home = () => (
  <>
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Laser Tag in Cornwall, Canada | Laser Zone Arena</title>
      <meta
        name="description"
        content="Experience the ultimate Laser Tag adventures in Cornwall, ON at Laser Zone Arena. Book public games, private parties, and birthday events. Open Wed–Sun 2 pm–10 pm."
      />
      <link rel="canonical" href="https://lazerzonearena.ca/" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://lazerzonearena.ca/" />
      <meta property="og:title" content="Laser Tag in Cornwall, Canada | Laser Zone Arena" />
      <meta
        property="og:description"
        content="Experience the ultimate Laser Tag adventures in Cornwall, ON at Laser Zone Arena. Book public games, private parties, and birthday events."
      />
      <meta property="og:image" content="https://lazerzonearena.ca/assets/hero.webp" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="https://lazerzonearena.ca/" />
      <meta name="twitter:title" content="Laser Tag in Cornwall, Canada | Laser Zone Arena" />
      <meta
        name="twitter:description"
        content="Experience the ultimate Laser Tag adventures in Cornwall, ON at Laser Zone Arena. Book public games, private parties, and birthday events."
      />
      <meta name="twitter:image" content="https://lazerzonearena.ca/assets/hero.webp" />

      {/* LocalBusiness JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EntertainmentBusiness",
          name: "Laser Zone Arena",
          url: "https://lazerzonearena.ca/",
          logo: "https://lazerzonearena.ca/assets/logo.png",
          image: "https://lazerzonearena.ca/assets/hero.webp",
          telephone: "+1-613-703-0489",
          address: {
            "@type": "PostalAddress",
            streetAddress: "917 Second St W",
            addressLocality: "Cornwall",
            addressRegion: "ON",
            postalCode: "K6J 1H8",
            addressCountry: "CA"
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: 45.0228,
            longitude: -74.7321
          },
          openingHours: ["Wed-Sun 14:00-22:00"],
          priceRange: "$$"
        })}
      </script>
    </Helmet>

    {/* Site Structure */}

    <main>
      <Hero />
      <About />
      <Pricing />
      <GrowthSections />

    </main>

  </>
);

export default Home;
